export function lp(str?: string): [string] {
  var msg = "[CVP] " + (str || "");
  return [msg.trim()];
}
